#import "../../../graphql/EntityDocumentsFields.graphql"
query PaymentDetails($id: UUID!) {
  payment(id: $id) {
    id
    _documentPackageId
    payCycleId
    _payCycleDescription
    payCycle {
      approvalHistorySignaturesByEntityId(
        orderBy: SORT_ORDER_ASC
        filter: {
          not: {
            isApproved: { equalTo: false }
            isRejected: { equalTo: false }
            isRequested: { equalTo: false }
          }
        }
      ) {
        nodes {
          id
          additionalInformation
          digitalSignature
          actionDate
          isApproved
          isRejected
          isRequested
          userName
          entityDocumentId
          userOccupationTitle
          userSignatureDocument {
            id
            _downloadLink
            fileIndexInformation
            fileReference
            iconType
          }
        }
      }
    }
    paidDate
    paymentReference
    paidAmount
    vendorReference
    currency {
      isoCode
    }
    statusType {
      approvalState
    }
    transactionType {
      transactionType
    }
    _accountingStampDate
    _accountingStampTransactionReference
    _accountingStampUserName
    _isAccountingEntryStampedComplete
    _isTransactionCancelled
    paymentHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
      totalCount
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _rowTimestamp
        _createdDate
        createdByUser
      }
    }
    invoicePayments {
      nodes {
        id
        _isTransactionPayment
        invoice {
          id
          description
          invoiceNumber
          vendorReference
          transactionType {
            id
            transactionType
            isDocumentSigningPayment
          }
          invoiceDate
          controlTotalAmount
        }
        _rowTimestamp
        _isUpdatable
        _isDeletable
      }
      aggregates {
        sum {
          appliedAmount
        }
      }
    }
  }
}
